import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import OverrideGeoIPPropertiesIntro from './override-geoip-properties-intro.mdx';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <OverrideGeoIPPropertiesIntro mdxType="OverrideGeoIPPropertiesIntro" />
    <p>{`Currently PostHog does `}<strong parentName="p">{`not`}</strong>{` provide a way to override GeoIP properties using our SDKs. Our API, however, does  allow you do this. See our API docs on `}<a parentName="p" {...{
        "href": "/docs/api/post-only-endpoints#overriding-geoip-properties"
      }}>{`how to override GeoIP properties`}</a>{` for more details. `}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      